export default "__VITE_ASSET__D0kEBByT__"